import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { RequestLoader, ToastContext } from "../../../hooks/context";
import { useExportVatLogsMutation } from "../../../hooks/api/mutations/useAccounting";
import { cleanObject, getRandomIntInclusive } from "../../../helpers";

const useVatLogsExport = ({
  closeWidget,
  selectStartDate,
  selectedEndDate,
}) => {
  const triggerToast = useContext(ToastContext);
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const [exportFormat, setExportFormat] = useState("pdf");
  const [startDate, setStartDate] = useState(selectStartDate || "");
  const [endDate, setEndDate] = useState(selectedEndDate || "");
  const [selectedStores, setSelectedStores] = useState([]);
  const [transactionType, setTransactionType] = useState("");
  const exportVatLogsMutation = useExportVatLogsMutation();

  const handleExportVatLog = () => {
    setRequestLoaderProgress(getRandomIntInclusive(10, 50));
    const data = {
      start_date: startDate,
      end_date: endDate,
      export_type: exportFormat,
      store_ids: selectedStores,
      transaction_type: transactionType,
    };
    exportVatLogsMutation.mutate(cleanObject(data), {
      onSuccess: (res) => {
        closeWidget();
        if (res?.data?.data?.status === "completed") {
          window.open(res?.data?.data?.download_url);
        } else {
          triggerToast(res?.data?.detail, "success");
        }
      },

      onSettled: () => setRequestLoaderProgress(100),
    });
  };

  return {
    exportFormat,
    startDate,
    endDate,
    selectedStores,
    storeList,
    transactionType,
    exportVatLogsMutation,
    setStartDate,
    setEndDate,
    setSelectedStores,
    setExportFormat,
    setTransactionType,
    handleExportVatLog,
  };
};

export default useVatLogsExport;
